// Core
import React from 'react';
import { Link } from 'react-router-dom';
import css from './style.scss';

class Home extends React.Component {
  componentDidMount() {
    this.props.setParentState({ showVideo: true })
  }
  render() {
    return (
      <div>
        <article className={ css.Home }>
          <p className={ css.p }>
            I'm Pete and I am a front end web developer. I have over 10 years of experience creating rich user experiences for clients large and small. I focus on standards compliant and modern methods of web development. When working on web apps or complex sites, I prefer ReactJS but have also worked extensively in AngularJS. Animations are powered by the Greensock Animation Platform.
          </p>
          <p className={ css.p }>
            <Link to="/work" className={ css.link }>Work</Link><br/>
            <Link to="/skills" className={ css.link }>Skills</Link>
          </p>
          <p className={ css.aaron }>
            Website art by <a href="http://aaronsather.com" target="_blank">Aaron Sather</a>
          </p>
        </article>
        <img src="/images/dog.jpg" className={ css.img } alt="fierce dog copyright Aaron Sather" />
      </div>
    )
  }
}

export default Home;


// WEBPACK FOOTER //
// ./app/js/components/Home/index.js